import { getConfigBaseUrl, getConfigGraphBaseUrl } from '../../../services/apiService';
import { apiCall, createApiThunk, graphqlCall } from '../../../utils/api';
import { print } from 'graphql';
import { getMyAccountsQuery } from './myAccountsQueries';
import { getCounterpartyId } from '../../../services/authService';

export const getMyAccountsThunk = createApiThunk('GET_MY_ACCOUNTS', graphqlCall);
export const saveMyAccountsThunk = createApiThunk('SAVE_MY_ACCOUNTS', apiCall);
export const editMyAccountsThunk = createApiThunk('EDIT_MY_ACCOUNTS', apiCall);

export const getMyAccounts = () => {
  return function (dispatch: AppDispatch) {
    const url = getConfigGraphBaseUrl();
    const query = print(getMyAccountsQuery);
    dispatch(getMyAccountsThunk({ url, query }));
  };
};

export const saveMyAccounts = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/accounts/`;
  return dispatch(saveMyAccountsThunk({ url, method: 'POST', data }));
};

export const editMyAccounts = (data: any) => (dispatch: AppDispatch) => {
  const url = `${getConfigBaseUrl()}/v2/config/tenants/${getCounterpartyId()}/accounts/${data.accountId}`;
  return dispatch(editMyAccountsThunk({ url, method: 'PUT', data }));
};
